import { render } from "./SettingsEmailsTemplates.vue?vue&type=template&id=a67260dc&scoped=true"
import script from "./SettingsEmailsTemplates.vue?vue&type=script&lang=js"
export * from "./SettingsEmailsTemplates.vue?vue&type=script&lang=js"

import "./SettingsEmailsTemplates.vue?vue&type=style&index=0&id=a67260dc&lang=scss"
import "./SettingsEmailsTemplates.vue?vue&type=style&index=1&id=a67260dc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a67260dc"]])

export default __exports__